document.addEventListener('DOMContentLoaded', function() {
  initCustomPanels();
  initAddToCartForms();
});

function initCustomPanels() {
  const panelContainers = document.querySelectorAll('[id^="custom-panel-"]');
  
  panelContainers.forEach(container => {
    const cards = Array.from(container.children);
    const prevButton = container.parentElement.querySelector('.custom-panel__prev-button');
    const nextButton = container.parentElement.querySelector('.custom-panel__next-button');
    
    if (cards.length < 2) return;
    
    let currentIndex = 0;
    let isDragging = false;
    let startX, startY;
    let currentX, currentY;
    
    // Set initial card positions
    updateCardPositions();
    
    // Add event listeners to buttons
    if (prevButton) {
      prevButton.addEventListener('click', () => {
        swipeCurrentCard('right');
      });
    }
    
    if (nextButton) {
      nextButton.addEventListener('click', () => {
        swipeCurrentCard('left');
      });
    }
    
    // Add direct card interaction - attach to container instead of individual cards
    container.addEventListener('mousedown', startDrag);
    container.addEventListener('touchstart', handleTouchStart, { passive: true });
    
    document.addEventListener('mousemove', drag);
    document.addEventListener('touchmove', handleTouchMove, { passive: false });
    
    document.addEventListener('mouseup', endDrag);
    document.addEventListener('touchend', handleTouchEnd);
    
    function handleTouchStart(e) {
      const touch = e.touches[0];
      startDrag(touch);
    }
    
    function handleTouchMove(e) {
      if (!isDragging) return;
      const touch = e.touches[0];
      drag(touch);
      // Prevent scrolling when swiping cards
      if (Math.abs(currentX - startX) > Math.abs(currentY - startY)) {
        e.preventDefault();
      }
    }
    
    function handleTouchEnd() {
      endDrag();
    }
    
    function startDrag(e) {
      const topCard = container.querySelector('.custom-panel__cover-card, .custom-panel__product-card');
      if (!topCard) return;
      
      isDragging = true;
      startX = e.clientX || e.pageX;
      startY = e.clientY || e.pageY;
      
      // Add active class for styling
      topCard.classList.add('dragging');
      
      // Set transition to none for smooth dragging
      topCard.style.transition = 'none';
    }
    
    function drag(e) {
      if (!isDragging) return;
      
      const topCard = container.querySelector('.custom-panel__cover-card, .custom-panel__product-card');
      if (!topCard) return;
      
      currentX = e.clientX || e.pageX;
      currentY = e.clientY || e.pageY;
      
      const diffX = currentX - startX;
      
      // Move the card horizontally with the drag
      topCard.style.transform = `rotate(3deg) translateX(${diffX}px) translateZ(0)`;
      
      // Adjust opacity based on drag distance
      if (Math.abs(diffX) > 100) {
        topCard.style.opacity = 1 - (Math.abs(diffX) - 100) / 200;
      }
    }
    
    function endDrag() {
      if (!isDragging) return;
      
      const topCard = container.querySelector('.custom-panel__cover-card, .custom-panel__product-card');
      if (!topCard) return;
      
      isDragging = false;
      
      // Reset transition
      topCard.style.transition = '';
      topCard.classList.remove('dragging');
      
      const diffX = currentX - startX;
      
      // Determine if swipe was significant enough
      if (Math.abs(diffX) > 100) {
        // Swipe direction based on drag
        swipeCurrentCard(diffX < 0 ? 'left' : 'right');
      } else {
        // Reset position if swipe wasn't far enough
        topCard.style.transform = 'rotate(3deg) translateZ(0)';
        topCard.style.opacity = '1';
      }
    }
    
    function swipeCurrentCard(direction) {
      const currentCard = cards[currentIndex];
      if (!currentCard) return;
      
      // Add the appropriate animation class
      currentCard.classList.add(direction === 'left' ? 'swipe-left' : 'swipe-right');
      
      // After animation completes, move the card to the end and reset
      setTimeout(() => {
        // Remove animation class
        currentCard.classList.remove('swipe-left', 'swipe-right');
        
        // Move current card to the end of the array
        cards.push(cards.shift());
        
        // Update positions
        updateCardPositions();
      }, 600); // Match this to the animation duration
    }
    
    function updateCardPositions() {
      // Reset all cards
      cards.forEach((card, index) => {
        card.style.zIndex = cards.length - index;
        
        if (index === 0) {
          // Top card
          card.style.opacity = '1';
          card.style.transform = 'rotate(3deg) translateZ(0)';
          card.style.pointerEvents = 'auto';
          card.style.transition = 'transform 0.3s ease, opacity 0.3s ease';
        } else if (index === 1) {
          // Second card (peeking from behind)
          card.style.opacity = '0.9';
          card.style.transform = 'translateZ(-10px) scale(0.98)';
          card.style.pointerEvents = 'none';
        } else {
          // Hidden cards
          card.style.opacity = '0';
          card.style.transform = 'translateZ(-20px) scale(0.95)';
          card.style.pointerEvents = 'none';
        }
      });
    }
  });
}

function initAddToCartForms() {
  const addToCartForms = document.querySelectorAll('.custom-panel__add-to-cart-form');
  
  addToCartForms.forEach(form => {
    form.addEventListener('submit', async function(e) {
      e.preventDefault();
      
      const button = form.querySelector('button[type="submit"]');
      const originalText = button.textContent;
      
      // Show loading state
      button.disabled = true;
      button.textContent = 'Adding...';
      
      try {
        const formData = new FormData(form);
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        });
        
        if (response.ok) {
          // Success feedback
          button.textContent = 'Added!';
          
          // Trigger cart update event (for themes that listen for it)
          document.dispatchEvent(new CustomEvent('cart:updated'));
          
          // Reset button after delay
          setTimeout(() => {
            button.disabled = false;
            button.textContent = originalText;
          }, 2000);
        } else {
          throw new Error('Failed to add to cart');
        }
      } catch (error) {
        console.error('Add to cart error:', error);
        button.textContent = 'Error';
        
        // Reset button after delay
        setTimeout(() => {
          button.disabled = false;
          button.textContent = originalText;
        }, 2000);
      }
    });
  });
}